module.exports = __webpack_public_path__ + "static/img/hn.a19cb414.svg";